var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41146",
    "data-name": "Group 41146",
    transform: "translate(21500 8530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15617",
    "data-name": "Rectangle 15617",
    width: 16,
    height: 16,
    transform: "translate(-21500 -8530)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    transform: "translate(-21503 -8533.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37036",
    "data-name": "Path 37036",
    d: "M4,15.583A.583.583,0,0,1,4.583,15H17.417a.583.583,0,1,1,0,1.167H4.583A.583.583,0,0,1,4,15.583Z",
    transform: "translate(0 -3.75)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37037",
    "data-name": "Path 37037",
    d: "M17.171,6.171a.583.583,0,0,1,.825,0l5.25,5.25a.583.583,0,0,1,0,.825L18,17.5a.583.583,0,0,1-.825-.825l4.838-4.838L17.171,7a.583.583,0,0,1,0-.825Z",
    transform: "translate(-5.417)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0cdde26dcc128326a8b8fc6b5f6cf6a6.svg";
export { ForwardRef as ReactComponent };